// Global styles and fonts (pruned variants to reduce CSS & requests)
import "@fontsource/work-sans/400.css";
import "@fontsource/work-sans/700.css";
import "@fontsource/cormorant-garamond/700.css";
import "@fontsource/lilita-one/400.css";
import "./src/styles/global.css";

export const onClientEntry = () => {
    // Language redirect only on first visit (no stored preference) and only for root path.
    try {
        if (typeof window === "undefined") return;
        const stored = localStorage.getItem("preferred_lang");
        if (stored) return; // user already chose
        const path = window.location.pathname;
        // Only redirect if at root or single slash
        if (path !== "/" && path !== "") return;
        const browserLang = (navigator.language || "en")
            .slice(0, 2)
            .toLowerCase();
        const supported = ["en", "pt"];
        if (supported.includes(browserLang) && browserLang !== "en") {
            window.location.replace(`/${browserLang}/`);
        }
    } catch (e) {
        // Silent fail; do not block page load.
    }
};

export const onRouteUpdate = ({ location }) => {
    try {
        if (typeof window === "undefined") return;
        // Store the language from the path as user preference.
        const match = location.pathname.split("/").filter(Boolean)[0];
        const maybeLang = ["en", "pt"].includes(match) ? match : "en";
        localStorage.setItem("preferred_lang", maybeLang);
    } catch (e) {
        // ignore
    }
};
